import { gql } from '@apollo/client'

export const PLAN_CREATE_MUTATION = gql`
  mutation PLAN_CREATE_MUTATION($input: PlanCreateInput!) {
    planCreate(input: $input) {
      ok
      data {
        id
        companyId
        name
        status
        ownedById
        businessActivities {
          id
        }
        businessProcesses {
          id
        }
        businessUnits {
          id
        }
        planType {
          id
          objectiveOwnerObjectSecurityId
          objectiveMemberObjectSecurityId
          actionOwnerObjectSecurityId
          actionMemberObjectSecurityId
          kpiOwnerObjectSecurityId
          kpiMemberObjectSecurityId
          planOwnerObjectSecurityId
          planMemberObjectSecurityId
        }
      }
    }
  }
`

export const PLAN_UPDATE_MUTATION = gql`
  mutation PLAN_UPDATE_MUTATION($id: ID!, $input: PlanUpdateInput!) {
    planUpdate(id: $id, input: $input) {
      ok
    }
  }
`

export const PLAN_DELETE_MUTATION = gql`
  mutation PLAN_DELETE_MUTATION($id: ID!) {
    planDelete(id: $id) {
      ok
    }
  }
`

export const PLAN_TREE_UPDATE_MUTATION = gql`
  mutation PLAN_TREE_UPDATE_MUTATION($input: [PlanUpdateTreeInput]) {
    planUpdateTree(input: $input) {
      ok
    }
  }
`

export const PLAN_ITEM_CREATE_MUTATION = gql`
  mutation PLAN_ITEM_CREATE_MUTATION($input: PlanItemCreateInput!) {
    planItemCreate(input: $input) {
      ok
      data {
        id
        createdAt
        parentId
        planId
        expanded
        treePosition
        referenced
        planKPI {
          id
          description
        }
        planAction {
          id
          description
        }
        planObjective {
          id
          description
        }
      }
    }
  }
`

export const PLAN_ITEM_DELETE_MUTATION = gql`
  mutation PLAN_ITEM_DELETE_MUTATION($id: ID!, $deleteSource: Boolean, $checkChildren: Boolean) {
    planItemDelete(id: $id, deleteSource: $deleteSource, checkChildren: $checkChildren) {
      ok
      data {
        id
      }
    }
  }
`

export const LINKING_ITEM_CREATE_MUTATION = gql`
  mutation LINKING_ITEM_CREATE_MUTATION($input: LinkingItemCreateInput!) {
    linkingItemCreate(input: $input) {
      data {
        id
        sourcePlanKPIId
        destinationPlanKPIId
        sourcePlanActionId
        destinationPlanActionId
        sourcePlanObjectiveId
        destinationPlanObjectiveId
        description
      }
    }
  }
`

export const LINKING_ITEM_UPDATE_MUTATION = gql`
  mutation LINKING_ITEM_UPDATE_MUTATION($id: ID!, $input: LinkingItemUpdateInput!) {
    linkingItemUpdate(id: $id, input: $input) {
      data {
        id
      }
    }
  }
`

export const LINKING_ITEM_DELETE_MUTATION = gql`
  mutation LINKING_ITEM_DELETE_MUTATION($id: ID!) {
    linkingItemDelete(id: $id) {
      ok
    }
  }
`
export const PLAN_ITEM_DELETE_BULK_REFERENCED_MUTATION = gql`
  mutation PLAN_ITEM_DELETE_BULK_REFERENCED_MUTATION($ids: [ID]!) {
    planItemDeleteBulkReferenced(ids: $ids) {
      ok
    }
  }
`

export const PLAN_BULK_ITEMS_UPDATE_MUTATION = gql`
  mutation PLAN_BULK_ITEMS_UPDATE_MUTATION($id: ID!, $input: JSON!) {
    planBulkItemsUpdate(id: $id, input: $input) {
      ok
    }
  }
`

export const PLAN_ITEM_SET_ARCHIVED_MUTATION = gql`
  mutation PLAN_ITEM_SET_ARCHIVED_MUTATION($id: ID!, $archived: Boolean!) {
    planItemSetArchived(id: $id, archived: $archived) {
      ok
    }
  }
`

export const PLAN_CLONE_MUTATION = gql`
  mutation PLAN_CLONE_MUTATION($id: ID!, $input: PlanCloneInput!) {
    planClone(id: $id, input: $input) {
      ok
      message
    }
  }
`

export const PLAN_SCHEDULE_DEFAULTS_SET_MUTATION = gql`
  mutation PLAN_SCHEDULE_DEFAULTS_SET_MUTATION($planId: ID!, $input: [PlanScheduleDefaultInput!]!) {
    planScheduleDefaultsSet(planId: $planId, input: $input) {
      ok
    }
  }
`
